<template>
    <section class="filter__info">
        <div v-if="$store.state.searchTerm" class="filter__info--search">
            <h2>{{$t('module.filter_info.search_results')}} "{{$store.state.searchTerm}}"</h2>
        </div>
        <div v-if="showFilter()" class="filter__info--filter">
            <span class="filter__text">{{$t('module.filter_info.filter')}}</span>
            <template v-for="filterGroups in filter"
                :key="filterGroups.value">
                <template v-for="filterEntry in filterGroups.entries"
                    :key="filterEntry.name">
                    <span class="tag__cloud"
                    v-if="filterEntry.selected"
                    @click="removeFilterEntry(filterEntry.id, filterGroups.value, true, filterEntry.label)">
                        <span>{{filterEntry.label}}</span>
                    <div class="bullet">
                        <svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 100 100">
                                <path d="M 6.3895625,6.4195626 C 93.580437,93.610437 93.580437,93.610437 93.580437,93.610437" style="fill:none;fill-rule:evenodd;stroke:#ffffff;stroke-width:18.05195999;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"/>
                                <path d="M 6.3894001,93.6106 C 93.830213,6.4194003 93.830213,6.4194003 93.830213,6.4194003" style="fill:none;fill-rule:evenodd;stroke:#ffffff;stroke-width:17.80202103;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"/>
                        </svg>
                    </div>
                    </span>
                </template>
            </template>
            <template v-for="filterEntry in rating.entries" :key="filterEntry.name">
                    <span class="tag__cloud"
                        v-if="filterEntry.selected"
                        @click="removeFilterEntry(filterEntry.id, filterGroups, true, filterEntry.label)">
                            <span>{{filterEntry.name}}+ Stars</span>
                            {{filterEntry}}
                        <div class="bullet">
                            <svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 100 100">
                                    <path d="M 6.3895625,6.4195626 C 93.580437,93.610437 93.580437,93.610437 93.580437,93.610437" style="fill:none;fill-rule:evenodd;stroke:#ffffff;stroke-width:18.05195999;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"/>
                                    <path d="M 6.3894001,93.6106 C 93.830213,6.4194003 93.830213,6.4194003 93.830213,6.4194003" style="fill:none;fill-rule:evenodd;stroke:#ffffff;stroke-width:17.80202103;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"/>
                            </svg>
                        </div>
                    </span>
            </template>
            
            <template v-for="filterEntry in downloads.entries" :key="filterEntry.name">
                <span class="tag__cloud"
                    v-if="filterEntry.selected"
                    @click="removeFilterEntry(filterEntry.id, filterGroups, true, filterEntry.label)">
                    <span>{{filterEntry.label}}</span>
                        <div class="bullet">
                            <svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 100 100">
                                <path d="M 6.3895625,6.4195626 C 93.580437,93.610437 93.580437,93.610437 93.580437,93.610437" style="fill:none;fill-rule:evenodd;stroke:#ffffff;stroke-width:18.05195999;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"/>
                                <path d="M 6.3894001,93.6106 C 93.830213,6.4194003 93.830213,6.4194003 93.830213,6.4194003" style="fill:none;fill-rule:evenodd;stroke:#ffffff;stroke-width:17.80202103;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"/>
                            </svg>
                        </div>
                    </span>
            </template>
            <span @click="removeFilter" class="filter__reset">{{$t('module.filter_info.reset')}}</span>
        </div>
    </section>
</template>

<script>
export default {
    name: 'FilterInfo',
    props: {
        searchterm: {
            type: String,
            required: false,
        },
        filter: {
            type: Object,
            required: false
        },
        creator: {
            type: Object,
            required: false
        },
        downloads: {
            type: Object,
            required: false
        },
        rating: {
            type: Object,
            required: false
        }
    },
    emits: ['remove-filterentry', 'remove-filter'],
    methods: {
        removeFilterEntry(id, filterby, selected, label) {
            this.$emit('remove-filterentry', id, filterby, selected, label)
        },
        removeFilter(){
            this.$emit('remove-filter');
        },
        showFilter(){
            for (const [filter_key, filter_value] of Object.entries(this.filter)) {
                if(filter_key != ""){
                    for (const [key, value] of Object.entries(filter_value)) {
                        if(key == "entries"){
                            for (const [ekey, evalue] of Object.entries(value)) {
                                if(evalue.selected){
                                    if(ekey != ''){
                                        return true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return false;
            
        }
    },
    created() {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h2{
        font-weight: normal;
    }
   .filter__info--searc,
   .filter__info--filter{
       padding-bottom: 25px;
   }
   .filter__text{
       font-size: 16px;
       line-height: 32px;
       display:inline-block;
       padding-right: 15px;
   }
   .filter__reset{
       cursor: pointer;
       color: #E73246;
       padding-left: 10px;
   }
</style>